import { type Till } from "~/api/tills/types";

const UNATTENDED_TILL_TYPES = [
  "kiosk",
  "self-service",
  "simple-checkout",
  "ticket-validation"
] as const;

/**
 * Unattended till types that require PIN verification to access menu pages
 */
type UnattendedTillType = (typeof UNATTENDED_TILL_TYPES)[number];

type UnattendedTill = Extract<Till, { type: UnattendedTillType }>;

/**
 * Type guard function that checks if a till is unattended.
 * Unattended tills require PIN verification to access menu pages (home, settings, etc.)
 */
export function isUnattendedTill(
  till: Till | null | undefined
): till is UnattendedTill {
  if (!till) return false;

  return (UNATTENDED_TILL_TYPES as readonly string[]).includes(till.type);
}

/**
 * Get the sell route for a given till type
 */
export function getSellRouteForTill(till: Till): string {
  switch (till.type) {
    case "kiosk":
      return "/kiosk";
    case "self-service":
      return "/pos";
    case "simple-checkout":
      return "/simple-checkout";
    case "ticket-validation":
      return "/ticket-validation";
    case "attended":
    case "collect":
      return "/pos";
    case "collect-lite":
      return "/collect";
    default:
      return "/pos";
  }
}
